import { useState } from "react";
import { toast } from "sonner";
import { Loader2, KeyRound } from "lucide-react";
import { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";

export default function ForgotPinDialog({ open, onClose, initialStoreCode, api }) {
  const [code, setCode] = useState(initialStoreCode || "");
  const [contact, setContact] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(null);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { const r = await api.forgotPin(code.trim().toUpperCase(), contact.trim()); setDone(r); }
    catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message); }
    finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) { onClose(); setDone(null); } }}>
      <DialogContent className="max-w-md" data-testid="forgot-pin-modal">
        <DialogHeader><DialogTitle className="flex items-center gap-2 font-serif"><KeyRound className="h-5 w-5 text-[#D46117]" /> Forgot PIN</DialogTitle>
          <DialogDescription>Enter your Metcash store number and the email or phone registered with Hasfarm. A new PIN will be emailed to your registered contact.</DialogDescription></DialogHeader>
        {done ? (
          <div data-testid="forgot-pin-result" className="rounded-xl bg-[#FBEEF4] p-4 text-sm text-[#28282E]">{done.message}{done.masked_to?.length ? <div className="mt-1 text-xs text-[#28282E]/70">Sent to {done.masked_to.join(", ")}</div> : null}</div>
        ) : (
          <form onSubmit={submit} className="space-y-3">
            <div><Label className="text-xs">Store ID / Metcash store number</Label><Input data-testid="forgot-pin-store" value={code} onChange={(e) => setCode(e.target.value)} required className="mt-1" placeholder="e.g. IGA123" /></div>
            <div><Label className="text-xs">Registered email or phone</Label><Input data-testid="forgot-pin-contact" value={contact} onChange={(e) => setContact(e.target.value)} required className="mt-1" placeholder="manager@store.com.au or 0400 000 000" /></div>
            <DialogFooter><Button type="button" variant="outline" onClick={onClose}>Cancel</Button><Button type="submit" data-testid="forgot-pin-submit" disabled={busy} className="bg-[#28282E] text-white hover:bg-[#1F1F24]">{busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : null} Send new PIN</Button></DialogFooter>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
}
